import { useEffect, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Input } from '../../../elements/input';
import { useTranslation } from 'react-i18next';
import { useHttpClient } from '../../../shared/http-client';
import { FormFooter } from '../../../elements/form-footer';
import { FieldError } from '../../../elements/field-error/field-error';
import { TextArea } from '../../../elements/text-area';
import { Toggle } from '../../../elements/toggle';


// construccion del objeto yup de validacion del cuestionario
let obligado = {
    name: Yup.string().required('obligatorio'),
    is_ordinary: Yup.boolean().required('obligatorio')
};
const validacion = Yup.object().shape(obligado);

const initialValues: any = {
    name: '',
    description: '',
    is_ordinary: false
};

export const TiposMantenimientoForm = ({
    item,
    close,
    doDelete
}: {
    item?: any;
    close: () => void;
    doDelete?: (item: any) => void;
}) => {
    const { t } = useTranslation() as { t: (key: string) => string };

    const { api, state } = useHttpClient();
    const [data, setData] = useState<any | null>(null);


    // Load initial data
    useEffect(() => {
        if (item) {
            setData(item);
        }
    }, [item]);

    const beforeSubmit = (values: any | null) => {
        const after = { ...values };

        return after;
    };

    const onSubmit = async (values: any | null) => {
        const enviaremos = beforeSubmit(values);

        if (enviaremos.id) {
            // update

            api(`/fleet/maintenance-types/${enviaremos.id}/`, 'PATCH', enviaremos);
        } else {
            // create

            api('/fleet/maintenance-types/', 'POST', enviaremos);
        }
    };

    // Handle API responses
    useEffect(() => {
        if (state.data) {
            if (state.path.includes('maintenance-types')) {
                if (state.method === 'POST' || state.method === 'PATCH') {
                    toast.success(`${t('common.label.success-saved')}`);
                    close();
                }
            }
        }

        if (state.error) {
            if (state.error.name) {
                toast.error(state.error.name[0]);
            }else{
                 toast.error('Server Error');
            }
        }
    }, [state]);

    return (
        <Formik
            initialValues={data || initialValues}
            onSubmit={onSubmit}
            validationSchema={validacion}
            enableReinitialize
        >
            {({
                values,
                errors,
                touched,
                setFieldValue,
                handleSubmit,
                isSubmitting
            }) => (
                <form onSubmit={handleSubmit} autoComplete="off">


                    <Input
                        label={t('common.label.name')}
                        type="text"
                        placeholder={t('common.label.name')}
                        name="name"
                        value={values.name}
                        onChange={(value) =>
                            setFieldValue('name', value.name)
                        }
                    />
                    <FieldError
                        touched={touched}
                        errors={errors}
                        field={'name'}
                    />

                    <div>
                        <TextArea
                            label={t(
                                'common.form-label.descripcion'
                            )}
                            placeholder={t(
                                'common.form-label.descripcion'
                            )}
                            name="description"
                            value={values.description}
                            onChange={(value: any) =>
                                setFieldValue(
                                    'description',
                                    value.description
                                )
                            }
                        />
                        <FieldError
                            touched={touched}
                            errors={errors}
                            field={'description'}
                        />
                    </div>
                    <Toggle
                        label={t('common.label.mantenimiento-ordinario')}
                        hasInfo
                        value={values.is_ordinary}
                        onChange={(value: any) =>
                            setFieldValue('is_ordinary', value.toggle)
                        }
                    />
                    <FieldError
                        touched={touched}
                        errors={errors}
                        field={'is_ordinary'}
                    />


                    <FormFooter
                        item={item}
                        doDelete={doDelete}
                        doSubmit={handleSubmit}
                        close={close}
                    />
                </form>
            )}
        </Formik>
    );
};